export default __webpack_public_path__ + "static/media/Vanessa Hoang - UX_UI Developer.5eb15ced.jpg";